import { isMobileScreen, setPageTitle } from "../common";
import ShopNavigationPanel from "./extra/ShopNavigationPanel";

function ReturnPolicy() {
  setPageTitle("Return & Refund Policy | Easy Returns & Money Back Guarantee");
  return (
    <>
      <section
        className="breadcrumbs-custom"
        data-preset='{"title":"Breadcrumbs","category":"header","reload":false,"id":"breadcrumbs"}'
      >
        <div className="breadcrumbs-custom-container">
          <ul className="breadcrumbs-custom-path">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span className="">Return Policy</span>
            </li>
          </ul>
        </div>
      </section>
      <section
        className={isMobileScreen() ? "bg-white" : "section-sm bg-white"}
      >
        <div className="container-xl">
          <div className="row row-40">
            {isMobileScreen() ? (
              <></>
            ) : (
              <div className="col-md-2">
                <ShopNavigationPanel />
              </div>
            )}
            <div className="col-md-10">
              <div className="container">
                <h1 className="h3 font-weight-bold mt-2">
                  Return & Refund Policy
                </h1>
                <div className="body-1">
                  We want you to be fully satisfied with your purchase. If for
                  any reason you are not, please review our return and refund
                  policy below.
                </div>

                <section className="mb-4 mt-4">
                  <h2 className="h4 section-title mb-2">Return Window</h2>
                  <div className="body-1">
                    We offer a <strong>14-day return policy</strong>, which
                    means you have 14 days after receiving your item to request
                    a return.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Eligibility for Returns
                  </h2>
                  <div className="body-1 mb-2">
                    <div>Be in the same condition you received them.</div>
                    <div>Be unused, unopened, and in original packaging.</div>
                    <div>
                      Include proof of purchase (receipt or order confirmation).
                    </div>
                    <div>
                      <strong>
                        Orders made using a gift card are not eligible for
                        refund.
                      </strong>
                    </div>
                  </div>
                  <div
                    className="body-2 text-warning"
                    style={{ fontSize: 14, marginTop: 8 }}
                  >
                    Please note: Consumable items (such as liquids, cartridges,
                    coils/pods, or batteries), personal care goods, custom
                    orders, sale items, promotional items, and gift cards are{" "}
                    <strong>non-returnable</strong>.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Damaged, Defective, or Incorrect Items
                  </h2>
                  <div className="body-1">
                    Please inspect your order upon delivery. Any cosmetic damage
                    from the manufacturer must be reported within{" "}
                    <strong>24 hours of delivery</strong>. If you receive a
                    defective, damaged, or incorrect item, contact us
                    immediately so we can evaluate and resolve the issue. We may
                    request photos or videos for faster processing and
                    troubleshooting before approving the return.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Promotional & Final Sale Items
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      Items marked as <strong>Final Sale</strong> or part of a{" "}
                      <strong>promotion</strong> cannot be returned or
                      exchanged.
                    </div>
                    <div>
                      If a promotional item is deemed defective, only a refund
                      or store credit will be offered. Replacements will not be
                      provided.
                    </div>
                    <div>
                      If you return other items from a promotional order, the
                      promotional item must also be returned. If not, the
                      non-promotional value of the item will be deducted from
                      your refund.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    How to Start a Return
                  </h2>
                  <div className="body-1">
                    To request a return, please email our customer support team
                    at <strong>{process.env.REACT_APP_SUPPORT_EMAIL}</strong>{" "}
                    with the following details:
                  </div>
                  <div className="body-1 mb-2">
                    <div>Order number</div>
                    <div>Full name</div>
                    <div>Address & phone number</div>
                    <div>Reason for return</div>
                  </div>
                  <div className="body-2">
                    If your return is approved, we will provide instructions on
                    how and where to ship your package.{" "}
                    <strong>
                      Items returned without prior approval will not be
                      accepted.
                    </strong>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Shipping & Fees</h2>
                  <div className="body-1 mb-2">
                    <div>
                      Customers are responsible for return shipping costs on
                      non-defective items.
                    </div>
                    <div>
                      All shipping charges are <strong>non-refundable</strong>.
                      If you received free shipping, our actual shipping cost
                      will be deducted from your refund.
                    </div>
                    <div>
                      Returns that are opened, used, show physical damage, or
                      are not properly cleaned may incur up to a{" "}
                      <strong>15% processing fee</strong>.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Exchanges</h2>
                  <div className="body-1">
                    The fastest way to get the item you want is to return your
                    original item (if eligible) and place a new order.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Refunds</h2>
                  <div className="body-1">
                    Once your return is received and inspected, we'll notify you
                    if your refund has been approved. If approved, a refund will
                    be issued to your original payment method within{" "}
                    <strong>10 business days</strong>.
                    <strong>
                      Orders made using a gift card are not eligible for refund.
                    </strong>
                    Please note that it may take additional time for your bank
                    or card provider to process and post the refund.
                  </div>
                  <div className="body-2">
                    If more than 15 business days have passed since your refund
                    was approved, please contact us at{" "}
                    <strong>{process.env.REACT_APP_SUPPORT_EMAIL}</strong>.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Refused Packages</h2>
                  <div className="body-1">
                    If an order is refused by the customer or shipping carrier,
                    shipping charges will not be refunded. A{" "}
                    <strong>15% return processing fee</strong> may also apply.
                  </div>
                </section>

                <footer className="mt-5">
                  <div className="font-weight-bold small">
                    *This is an auto-generated policy. Please contact support
                    for any questions.
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ReturnPolicy;
